import { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "@/App";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useContext(AppContext);
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0C0E] px-4">
      <div className="card-surface max-w-md p-10 text-center" data-testid="payment-cancel-page">
        <XCircle className="mx-auto mb-4 h-12 w-12 text-neutral-500" />
        <h1 className="font-display text-3xl font-semibold text-white">{t.payment.cancelTitle}</h1>
        <p className="mt-3 text-sm text-neutral-400">{t.payment.cancelSub}</p>
        <Link to="/" data-testid="cancel-home-link" className="btn-gold mt-8">{t.payment.backHome}</Link>
      </div>
    </div>
  );
}
